import { Action } from '@ngrx/store';
import { type } from '../../util';

export const ActionTypes = {
  SET_IS_HOSPITAL_BOOKING: type('[Hospital booking] Set is hospital booking flag'),
};

export class SetIsHospitalBooking implements Action {
  type = ActionTypes.SET_IS_HOSPITAL_BOOKING;

  constructor(public payload: boolean) { }
}

export type Action = SetIsHospitalBooking;


// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/hospital-booking/store/hospital-booking.actions.ts